










































import { Component, Vue } from "vue-property-decorator";

const events = {
  send: Symbol("send"),
  receive: Symbol("receive"),
  add: Symbol("add")
};

@Component
class Actions extends Vue {
  createModal = false;

  get actions() {
    return [
      // {
      //   text: this.$t("common.balance.deposit"),
      //   icon: this.$icons.mdiArrowDown,
      //   color: "#009621",
      //   size: "26",
      //   event: events.receive
      // },
      {
        text: this.$t("common.balance.withdraw"),
        icon: this.$icons.mdiArrowUp,
        color: "#F50000",
        size: "26",
        event: events.send
      },
      {
        text: this.$t("hfox.plan.new"),
        icon: "$vuetify.icons.iconPlus",
        color: "#008DDC",
        size: "16",
        event: events.add
      }
    ];
  }

  handleActionClick(action) {
    switch (action.event) {
      case events.send:
        this.handleSend();
        break;
      case events.receive:
        this.handleReceive();
        break;
      case events.add:
        this.handleAdd();
        break;
    }
  }

  handleSend() {
    this.$emit("withdraw");
  }

  handleReceive() {
    this.$emit("deposit");
  }

  handleAdd() {
    this.createModal = true;
  }

  handleToCreateLPPlan() {
    this.$helper.toFusionPath(this, "hfox", {
      name: "plan-create",
      query: {
        type: "lp"
      }
    });
  }

  handleToCreatePlan() {
    this.$helper.toFusionPath(this, "hfox", {
      name: "plan-create"
    });
  }
}
export default Actions;
